import { Ref, isRef } from 'vue';

export function formatCurrency(amount: number, countryCode: string | Ref<string> = 'fr-CA', currency: string = 'CAD'): string {
  const resolved = isRef(countryCode) ? countryCode.value : countryCode;
  const formatter = new Intl.NumberFormat(resolved, {
    style: 'currency',
    currency,
  });

  return formatter.format(amount);
}

export function formatCurrencyWithoutDecimal(amount: number, countryCode: string | Ref<string> = 'fr-CA', currency: string = 'CAD', currencyDisplay: string | null = null): string {
  const resolved = isRef(countryCode) ? countryCode.value : countryCode;
  const formatter = new Intl.NumberFormat(resolved, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    currencyDisplay: currencyDisplay || 'symbol'
  });
  
  return formatter.format(amount);
}
